import { createAction, props } from '@ngrx/store';

import { CropAid } from '../crop-aid.model';

export const getGenericCropAids = createAction('[Crop aid] Get generic crop aids');

export const getProprietaryCropAids = createAction('[Crop aid] Get proprietary crop aids');

export const setGenericCropAids = createAction(
  '[Crop aid] Set generic crop aids',
  props<{ cropAids: CropAid[] }>(),
);

export const setProprietaryCropAids = createAction(
  '[Crop aid] Set proprietary crop aids',
  props<{ cropAids: CropAid[] }>(),
);
